import R from 'ramda';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';

import * as actions from '../actions';
import { getUserById } from './users';
import { getQuestionnaireTemplateById } from './questionnaireTemplates';
import { getLightCompanyById } from './companies';

function byId(state = {}, action) {
  switch (action.type) {
    case actions.REQUEST_QUESTIONNAIRELIST_SUCCESS:
    case actions.REQUEST_REVIEWING_QUESTIONNAIRES_SUCCESS:
      return Object.assign({}, state, action.data.items.entities.questionnaires);
    case actions.REQUEST_QUESTIONNAIRE_SUCCESS:
    case actions.UPDATE_QUESTIONNAIRE_SUCCESS:
    case actions.SEND_QUESTIONNAIRE_SUCCESS:
    case actions.APPROVE_QUESTIONNAIRE_SUCCESS:
    case actions.REJECT_QUESTIONNAIRE_SUCCESS:
    case actions.SET_QUESTIONNAIRE_TO_DRAFT_SUCCESS:
      return Object.assign({}, state, action.data.response.entities.questionnaires);
    case actions.REQUEST_ORDER_SUCCESS:
    case actions.PLACE_ORDER_NATIONAL_SUCCESS:
      return Object.assign({}, state, action.data.response.entities.questionnaires);
    case actions.QUESTIONNAIRE_ASSIGNUSER_SUCCESS:
      return Object.assign({}, state, action.data.entities.questionnaires);
    case actions.UPLOAD_FILE_QUESTIONNAIRE_SUCCESS: {
      const questionnaire = Object.assign({}, state[action.id]);
      const file = action.file;
      const fieldId = Number(action.dataset.field);

      if (action.dataset.group && action.dataset.fieldpos) {
        const groupId = Number(action.dataset.group);
        const fieldPos = Number(action.dataset.fieldpos);
        const group = questionnaire.groups[groupId];
        const field = group.fields[fieldPos][fieldId];
        field.value = file;
      } else {
        const field = questionnaire.fields[fieldId];
        field.value = file;
      }

      return Object.assign({}, state, {
        [action.id]: questionnaire,
      });
    }
    case actions.DELETE_FILE_QUESTIONNAIRE_SUCCESS: {
      const data = action.data;
      const questionnaire = Object.assign({}, state[action.id]);

      if (data.length > 1) {
        const actionGroup = action.data[0];
        const actionField = action.data[1];
        const fieldPos = action.data[2];
        questionnaire
          .groups[actionGroup.id]
          .fields[fieldPos][actionField.id].value = null;
      } else {
        const actionField = action.data[0];
        questionnaire.fields[actionField.id].value = null;
      }

      return Object.assign({}, state, {
        [action.id]: questionnaire,
      });
    }
    default:
      return Object.assign({}, state);
  }
}

function ids(state = [], action) {
  switch (action.type) {
    case actions.REQUEST_QUESTIONNAIRELIST_SUCCESS:
      return R.uniq(Object.assign([], state, action.data.items.result));
    case actions.REQUEST_QUESTIONNAIRE_SUCCESS:
    case actions.UPDATE_QUESTIONNAIRE_SUCCESS:
    case actions.SEND_QUESTIONNAIRE_SUCCESS:
    case actions.APPROVE_QUESTIONNAIRE_SUCCESS:
    case actions.REJECT_QUESTIONNAIRE_SUCCESS:
    case actions.SET_QUESTIONNAIRE_TO_DRAFT_SUCCESS:
      return R.uniq(Object.assign([], state, [action.data.response.result]));
    default:
      return Object.assign([], state);
  }
}

function reviewingIds(state = [], action) {
  switch (action.type) {
    case actions.REQUEST_REVIEWING_QUESTIONNAIRES_START:
      return action.params.page === 1
        ? []
        : Object.assign([], state);
    case actions.REQUEST_REVIEWING_QUESTIONNAIRES_SUCCESS:
      return Object.assign([], action.data.items.result);
    case actions.APPROVE_QUESTIONNAIRE_SUCCESS: {
      const updatedReviewingQuestionnairesList =
        R.filter(id => id !== action.questionnaireId, state);
      return Object.assign([], updatedReviewingQuestionnairesList);
    }
    default:
      return Object.assign([], state);
  }
}

function loading(state = false, action) {
  switch (action.type) {
    case actions.REQUEST_QUESTIONNAIRELIST_START:
    case actions.REQUEST_QUESTIONNAIRE_START:
    case actions.UPDATE_QUESTIONNAIRE_START:
    case actions.UPLOAD_FILE_QUESTIONNAIRE_START:
    case actions.DELETE_FILE_QUESTIONNAIRE_START:
    case actions.SEND_QUESTIONNAIRE_START:
    case actions.QUESTIONNAIRE_ASSIGNUSER_START:
    case actions.REJECT_QUESTIONNAIRE_START:
    case actions.APPROVE_QUESTIONNAIRE_START:
    case actions.REQUEST_REVIEWING_QUESTIONNAIRES_START:
    case actions.SET_QUESTIONNAIRE_TO_DRAFT_START:
      return true;
    case actions.REQUEST_QUESTIONNAIRELIST_SUCCESS:
    case actions.REQUEST_QUESTIONNAIRELIST_ERROR:
    case actions.REQUEST_QUESTIONNAIRE_SUCCESS:
    case actions.REQUEST_QUESTIONNAIRE_ERROR:
    case actions.UPDATE_QUESTIONNAIRE_SUCCESS:
    case actions.UPDATE_QUESTIONNAIRE_ERROR:
    case actions.UPLOAD_FILE_QUESTIONNAIRE_SUCCESS:
    case actions.UPLOAD_FILE_QUESTIONNAIRE_ERROR:
    case actions.DELETE_FILE_QUESTIONNAIRE_SUCCESS:
    case actions.DELETE_FILE_QUESTIONNAIRE_ERROR:
    case actions.SEND_QUESTIONNAIRE_SUCCESS:
    case actions.SEND_QUESTIONNAIRE_ERROR:
    case actions.QUESTIONNAIRE_ASSIGNUSER_ERROR:
    case actions.QUESTIONNAIRE_ASSIGNUSER_SUCCESS:
    case actions.REJECT_QUESTIONNAIRE_SUCCESS:
    case actions.REJECT_QUESTIONNAIRE_ERROR:
    case actions.SET_QUESTIONNAIRE_TO_DRAFT_SUCCESS:
    case actions.SET_QUESTIONNAIRE_TO_DRAFT_ERROR:
    case actions.SET_BUSINESSINFO_TO_DRAFT_SUCCESS:
    case actions.SET_BUSINESSINFO_TO_DRAFT_ERROR:
    case actions.APPROVE_QUESTIONNAIRE_SUCCESS:
    case actions.APPROVE_QUESTIONNAIRE_ERROR:
    case actions.REQUEST_REVIEWING_QUESTIONNAIRES_SUCCESS:
    case actions.REQUEST_REVIEWING_QUESTIONNAIRES_ERROR:
      return false;
    default:
      return state;
  }
}

function error(state = null, action) {
  switch (action.type) {
    case actions.REQUEST_QUESTIONNAIRELIST_START:
    case actions.REQUEST_QUESTIONNAIRE_START:
    case actions.UPDATE_QUESTIONNAIRE_START:
    case actions.UPLOAD_FILE_QUESTIONNAIRE_START:
    case actions.DELETE_FILE_QUESTIONNAIRE_START:
    case actions.SEND_QUESTIONNAIRE_START:
    case actions.REQUEST_QUESTIONNAIRELIST_SUCCESS:
    case actions.REQUEST_QUESTIONNAIRE_SUCCESS:
    case actions.UPDATE_QUESTIONNAIRE_SUCCESS:
    case actions.DELETE_FILE_QUESTIONNAIRE_SUCCESS:
    case actions.SEND_QUESTIONNAIRE_SUCCESS:
    case actions.QUESTIONNAIRE_ASSIGNUSER_START:
    case actions.QUESTIONNAIRE_ASSIGNUSER_SUCCESS:
    case actions.REJECT_QUESTIONNAIRE_START:
    case actions.REJECT_QUESTIONNAIRE_SUCCESS:
    case actions.APPROVE_QUESTIONNAIRE_START:
    case actions.APPROVE_QUESTIONNAIRE_SUCCESS:
    case actions.REQUEST_REVIEWING_QUESTIONNAIRES_START:
    case actions.REQUEST_REVIEWING_QUESTIONNAIRES_SUCCESS:
    case actions.SET_QUESTIONNAIRE_TO_DRAFT_START:
    case actions.SET_QUESTIONNAIRE_TO_DRAFT_SUCCESS:
      return null;
    case actions.REQUEST_QUESTIONNAIRELIST_ERROR:
    case actions.REQUEST_QUESTIONNAIRE_ERROR:
    case actions.UPDATE_QUESTIONNAIRE_ERROR:
    case actions.UPLOAD_FILE_QUESTIONNAIRE_ERROR:
    case actions.DELETE_FILE_QUESTIONNAIRE_ERROR:
    case actions.SEND_QUESTIONNAIRE_ERROR:
    case actions.QUESTIONNAIRE_ASSIGNUSER_ERROR:
    case actions.REJECT_QUESTIONNAIRE_ERROR:
    case actions.APPROVE_QUESTIONNAIRE_ERROR:
    case actions.REQUEST_REVIEWING_QUESTIONNAIRES_ERROR:
    case actions.SET_QUESTIONNAIRE_TO_DRAFT_ERROR:
    case actions.SET_BUSINESSINFO_TO_DRAFT_ERROR:
      return action.err.message || process.env.ERR_GENERIC;
    default:
      return state;
  }
}

function total(state = 0, action) {
  switch (action.type) {
    case actions.REQUEST_REVIEWING_QUESTIONNAIRES_SUCCESS:
      return action.data.total;
    default:
      return state;
  }
}

const questionnaires = combineReducers({
  byId,
  ids,
  loading,
  error,
  total,
  reviewingIds,
});

export default questionnaires;

export const $getLoading = state => state.questionnaires.loading;

export const getQuestionnaireById = (state, id) => {
  const $questionnaire = state.questionnaires.byId[id];
  return $questionnaire && Object.assign({}, $questionnaire, {
    contactUser: (
      $questionnaire.contactUser && getUserById(state, $questionnaire.contactUser)) || {},
    template: $questionnaire.template &&
      getQuestionnaireTemplateById(state, $questionnaire.template),
    company: $questionnaire.company && getLightCompanyById(state, $questionnaire.company),
  });
};

export const getReviewingQuestionnaires = state => (state.questionnaires.reviewingIds || [])
  .map(questionnaireId => getQuestionnaireById(state, questionnaireId));

export const getReviewingQuestionnairesTotal =
  state => (state.questionnaires.reviewingIds || []).length;

export const getLoading = createSelector(
  $getLoading,
  $loading => $loading);
